import { render, staticRenderFns } from "./InvoicesPage.vue?vue&type=template&id=94376944&"
import script from "./InvoicesPage.vue?vue&type=script&lang=js&"
export * from "./InvoicesPage.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesPage.vue?vue&type=style&index=0&id=94376944&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports